import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { financialInstitutionRoles } from 'commons/types/dictionaries'
import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

const EMPTY_OPTION = { label: 'Not selected', value: '' }

export const RoleInTransaction = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const noBranchInvolved = useWatch({ control, name: `institutionActivitiesInfo.${index1 as 0}.noBranchInvolved` })

  return (
    <Controller
      name={`institutionActivitiesInfo.${index1 as 0}.institutionActivityBranchesInfo.${index2 as 0}.roleInTransaction`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="68. Branch's role in transaction"
          input={(props) => (
            <Select
              {...props}
              data={financialInstitutionRoles}
              emptyOption={EMPTY_OPTION}
              disabled={noBranchInvolved}
            />
          )}
        />
      )}
    />
  )
}
